import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { FlatButton } from '@travel/ui';

import { setIsFindARoomBtnPresent } from 'store/providerInformation/actions';

import { TAB_ID } from 'constants/providerInfoTabIds';
import { Translate } from 'core/translate';

import styles from './findARoomButton.module.scss';

type Props = {
  /** state to capture current active tab */
  activeTabId?: string;
  /** Callback to be called when button is clicked */
  onClickFindARoomButton: () => void;
};

export default function FindARoomButton(props: Props) {
  const { activeTabId, onClickFindARoomButton } = props;
  const isMobile = useDeviceType() === MOBILE_SCREEN;

  const isRoomsAndPlansActiveTab = activeTabId === TAB_ID.ROOMS_AND_PLANS;

  const dispatch = useDispatch();

  useEffect(() => {
    isMobile && dispatch(setIsFindARoomBtnPresent(!isRoomsAndPlansActiveTab));
    return () => {
      isMobile && dispatch(setIsFindARoomBtnPresent(false));
    };
  }, [dispatch, isMobile, isRoomsAndPlansActiveTab]);

  if (isRoomsAndPlansActiveTab) {
    return null;
  }

  const button = (
    <FlatButton
      className={styles.findARoomButton}
      onClick={onClickFindARoomButton}
      data-testid="providerInformation-findARoomButton"
    >
      <Translate id="Provider_Info.Navigation.Find_a_room" className={styles.findARoomText} />
    </FlatButton>
  );
  return isMobile ? (
    <div
      className={styles.findARoomButtonContainer}
      data-testid="providerInformation-findARoomButton-wrapper"
    >
      {button}
    </div>
  ) : (
    button
  );
}
